import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import Link from '../Link'
import Icon from '../Icon'

export const Container = styled(Link)`
  ${({ theme }) => theme.textStyles.m375_buttonSmall}
  position: relative;
  display: inline-flex;
  flex-flow: row nowrap;
  gap: ${pxToRem(4)};
  align-items: center;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black};
  &::before {
    content: '';
    position: absolute;
    z-index: 1;
    inset: 0 0 0 0;
    background: ${({ theme }) => theme.colors.white};
    transition: transform 0.3s ease-in-out;
    transform: translateY(-100%);
  }
  &:hover::before,
  &:focus::before,
  &[aria-expanded='true']::before {
    transform: translateY(-0%);
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_button}
  }
`
export const Label = styled.span`
  position: relative;
  z-index: 2;
  ${Container}:focus &,
  ${Container}:hover & {
    text-decoration: underline;
  }
`
export const _Icon = styled(Icon)`
  position: relative;
  z-index: 2;
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(16)};
  transition: transform 0.3s ease-in-out;
  ${Container}:focus &,
  ${Container}:hover & {
    transform: translate(${pxToRem(2)}, ${pxToRem(-2)});
  }
  @media ${mq(sizes.desktop)} {
    width: ${pxToRem(24)};
  }
`
